"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.title = exports.price = exports.listingInfo = exports.listingCard = exports.infoSection = exports.image = exports.featureText = exports.featureGroup = exports.feature = exports.agentPhoto = exports.agentName = exports.agentInfo = exports.agentDetails = exports.agencyLogo = exports.addressLine = exports.addressContainer = void 0;
var _core = require("@emotion/core");
var _feBrary = require("@domain-group/fe-brary");
var _feCoAllhomesDesignSystem = require("@domain-group/fe-co-allhomes-design-system");
var _common = require("../common.style");
var colour = _feBrary.variables.colour,
  font = _feBrary.variables.font;
var listingCard = exports.listingCard = /*#__PURE__*/(0, _core.css)("position:relative;display:flex;flex-wrap:nowrap;background-color:", colour.white, ";max-width:100%;");
var image = exports.image = {
  name: "13993l3",
  styles: "width:415px;height:385px;object-fit:cover;"
};
var infoSection = exports.infoSection = {
  name: "x8b3kr",
  styles: "flex-grow:1;padding:0 5px;display:flex;flex-direction:column;align-items:center;text-align:center;overflow:hidden;"
};
var title = exports.title = /*#__PURE__*/(0, _core.css)("font-family:", font.headingFontFamily, ";font-weight:600;font-size:", font.smallFontSize, ";line-height:18px;color:", colour.accent, ";border-bottom:2px solid ", colour.accent, ";padding-bottom:12px;margin-top:30px;");
var listingInfo = exports.listingInfo = /*#__PURE__*/(0, _core.css)(_feCoAllhomesDesignSystem.typography.bodyLongNoLinks, " color:", colour.neutral700, ";display:flex;flex-direction:column;margin-top:40px;width:100%;");
var price = exports.price = /*#__PURE__*/(0, _core.css)(_feCoAllhomesDesignSystem.typography.headingM, " line-height:28px;");
var addressContainer = exports.addressContainer = /*#__PURE__*/(0, _core.css)(_feBrary.aNormalize, " max-width:100%;", _common.expandClickZone);
var addressLine = exports.addressLine = {
  name: "b00fp5",
  styles: "display:inline-block;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;max-width:100%;"
};
var featureGroup = exports.featureGroup = {
  name: "ehcz25",
  styles: "margin-top:25px;display:flex;gap:10px;justify-content:center;"
};
var feature = exports.feature = {
  name: "1dnaxzp",
  styles: "display:flex;align-items:center;gap:5px;"
};
var featureText = exports.featureText = /*#__PURE__*/(0, _core.css)(_feCoAllhomesDesignSystem.typography.bodyBold);
var agentInfo = exports.agentInfo = {
  name: "vfsjyv",
  styles: "margin-top:30px;display:flex;gap:5px;justify-content:center;"
};
var agentDetails = exports.agentDetails = {
  name: "1gnc3qn",
  styles: "display:flex;flex-direction:column;gap:5px;"
};
var agentName = exports.agentName = /*#__PURE__*/(0, _core.css)(_feCoAllhomesDesignSystem.typography.bodySmall, " line-height:14px;");
var agentPhoto = exports.agentPhoto = {
  name: "ocs6nn",
  styles: "height:46px;width:46px;"
};
var agencyLogo = exports.agencyLogo = {
  name: "12zccz6",
  styles: "width:100px;height:25px;object-fit:contain;object-position:left;"
};